import useSettingForm from '../form/useSettingForm';
import { useDomain } from '../../../../states/AppDomainProvider';
import RedXPrompting from '../../../settings/interaction/RedXPrompting';

const RedXPromptingSettings = () => {
  const { updateProfileSettingsOnChange } = useSettingForm('Red X Prompting');
  const { userDomain } = useDomain();
  const { userProfile } = userDomain.domainData;

  const onChange = (newValue) => {
    updateProfileSettingsOnChange({
      prompt: newValue,
    });
  };

  return (
    <RedXPrompting
      profile={userProfile}
      onChangeCallback={(newValue) => onChange(newValue)}
    />
  );
};

export default RedXPromptingSettings;
